import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LANGUAGES } from "../i18n";

export const Header = ({ t, lang, setLang }) => {
  const [open, setOpen] = useState(false);

  const links = [
    { href: "/#leistungen", label: t.nav.services, testid: "nav-services-link" },
    { href: "/#team", label: t.nav.team, testid: "nav-team-link" },
    { href: "/#projekte", label: t.nav.projects, testid: "nav-projects-link" },
    { href: "/#kontakt", label: t.nav.contact, testid: "nav-contact-link" },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 w-full z-50 bg-[#08080a]/80 backdrop-blur-xl border-b border-white/10"
    >
      <div data-testid="header-contact-bar" className="border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1.5 sm:py-0 sm:h-9 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-0.5 sm:gap-0 font-mono-accent text-[10px] md:text-[11px] tracking-wider text-neutral-500">
          <span className="truncate">
            {t.header.contactLabel}: <span className="text-pink-brand">Remo Vollmer</span>
            <span className="hidden lg:inline text-pink-brand"> · Hinwilerstrasse 11, 8626 Ottikon</span>
          </span>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-0.5 sm:gap-4 md:gap-6 shrink-0">
            <a data-testid="header-phone-link" href="tel:+41449353303" className="whitespace-nowrap hover:brightness-125 transition-[filter] duration-200"><span className="text-neutral-500">Tel. Nr.</span> <span className="text-pink-brand">+41 44 935 33 03</span></a>
            <a data-testid="header-email-link" href="mailto:r.vollmermontagen@gmail.com" className="whitespace-nowrap hover:brightness-125 transition-[filter] duration-200"><span className="text-neutral-500">E-Mail:</span> <span className="text-pink-brand">r.vollmermontagen@gmail.com</span></a>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="/" data-testid="logo-home-link" className="flex items-center gap-3 shrink-0">
          <img src="/logo-mark.png" alt="Vollmermontagen GmbH" className="h-9 md:h-11 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="font-mono-accent text-xs uppercase tracking-[0.2em] text-pink-brand hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-1" data-testid="language-switcher">
          {LANGUAGES.map((l, i) => (
            <span key={l.code} className="flex items-center">
              {i > 0 && <span className="text-neutral-700 mx-1">|</span>}
              <button
                data-testid={`lang-toggle-${l.code}`}
                onClick={() => setLang(l.code)}
                className={`font-mono-accent text-xs tracking-widest px-1 transition-colors duration-200 ${
                  lang === l.code ? "text-pink-brand font-bold" : "text-neutral-500 hover:text-white"
                }`}
              >
                {l.label}
              </button>
            </span>
          ))}
        </div>

        <button
          data-testid="mobile-menu-button"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#08080a]/95 backdrop-blur-xl" data-testid="mobile-menu">
          <div className="px-4 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-${l.testid}`}
                onClick={() => setOpen(false)}
                className="font-mono-accent text-sm uppercase tracking-[0.2em] text-pink-brand hover:text-white transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
            <div className="flex items-center gap-3 pt-2 border-t border-white/10">
              {LANGUAGES.map((l) => (
                <button
                  key={l.code}
                  data-testid={`mobile-lang-toggle-${l.code}`}
                  onClick={() => setLang(l.code)}
                  className={`font-mono-accent text-sm tracking-widest ${
                    lang === l.code ? "text-pink-brand font-bold" : "text-neutral-500"
                  }`}
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
